import React from 'react';
import _ from 'lodash';
import { useQuery, useMutation } from 'react-fetching-library';
import { Box, Modal, Card, CardContent, CardHeader, Checkbox, IconButton, List, ListItem, ListItemIcon, ListItemText, TextField, Stack, Typography, Button, OutlinedInput, Portal } from '@mui/material';

import { getInvoiceFieldsAction, downloadInvoiceSpreadsheet } from '../../../../services/request';

import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};


export default function DocumentsSpreadsheetModal ({ handleClose, documents }) {
  const [fields, setFields] = React.useState([]);
  const [checked, setChecked] = React.useState([]);
  const { loading, payload, error } = useQuery(getInvoiceFieldsAction());
  const { mutate } = useMutation(downloadInvoiceSpreadsheet);

  const handleToggle = value => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleCheckAll = () => setChecked(fields.map((field, index) => index));

  const handleRenumberPostions = () => setFields(prev => prev.map((field, index) => ({ ...field, position: index + 1 })));

  const handleAlignWidth = () => setFields(prev => prev.map(field => ({ ...field, width: 15 })));

  const handleWidthChange = (e, index) => {
    const value = _.isNaN(parseInt(e.target.value)) ? '' : parseInt(e.target.value);

    setFields(prev => prev.map((field, i) => i === index ? { ...field, width: value } : field));
  };

  const handlePositionChange = (e, index) => {
    const value = _.isNaN(parseInt(e.target.value)) ? '' : parseInt(e.target.value);

    setFields(prev => prev.map((field, i) => i === index ? { ...field, position: value } : field));
  };

  const handleDownload = async () => {
    const checkedFields = fields.filter((field, index) => checked.indexOf(index) !== -1);
    const idList = documents.map(document => document.id);
    const { error: mutateError, payload: mutatePayload } = await mutate({ 'id_list': idList, 'fields': checkedFields });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Raport.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    }
  };

  React.useEffect(() => {
    if (!error && !loading) {
      const result = payload.result.map((field, index) => ({ ...field, width: 15, position: index + 1 }));
      setFields(result);
      setChecked(payload.result.map((field, index) => index));
    }
  }, [loading]);


  return (
    <Portal>
      <Modal open={true}>
        <Card sx={{ ...style, height: '90vh', minWidth: '1100px', display: 'flex', flexDirection: 'column' }}>
          <CardHeader
            title="Wygeneruj raport"
            action={
              <IconButton color="primary" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            }
          />
          <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <List sx={{ flex: '0.80', overflow: 'auto' }}>
              {fields.map((field, index) => (
                <ListItem key={index} >
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      onChange={handleToggle(index)}
                      checked={checked.indexOf(index) !== -1}
                    />
                  </ListItemIcon>
                  <ListItemText primary={field.verbose_name} />
                  <Stack direction="row" spacing={4}>
                    <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
                      <Typography variant="subtitle2">Szerokość: </Typography>
                      <OutlinedInput value={field.width} onChange={e => handleWidthChange(e, index)} type="number"></OutlinedInput>
                    </Stack>
                    <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
                      <Typography variant="subtitle2">Pozycja: </Typography>
                      <OutlinedInput value={field.position} onChange={e => handlePositionChange(e, index)} type="number"></OutlinedInput>
                    </Stack>
                  </Stack>
                </ListItem>
              ))}
            </List>
            <Stack sx={{ flex: '0.15' }} direction="column" alignItems="center" justifyContent="center" spacing={2}>
              <Stack direction="row" spacing={2}>
                <Button variant="outlined" onClick={handleCheckAll}>Zaznacz wszystkie</Button>
                <Button variant="outlined" onClick={() => setChecked([])}>Odznacz wszysykie</Button>
                <Button variant="outlined" onClick={handleRenumberPostions}>Renumeruj pozycje</Button>
                <Button variant="outlined" onClick={handleAlignWidth}>Wyrównaj szerokości</Button>
              </Stack>
              <Button variant="contained" onClick={handleDownload}>Pobierz raport</Button>
            </Stack>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
